import shuffle from 'lodash/shuffle';
import { Training } from '@/interfaces/class/training';

export default (el: Training) => {
  const enFillersShuffled : any = {};

  shuffle(el.en.split('')).forEach((letter: string) => {
    const smallLetter = letter.toLocaleLowerCase();

    enFillersShuffled[smallLetter] = {
      letter: smallLetter,
      count: (enFillersShuffled[smallLetter] ? enFillersShuffled[smallLetter].count : 0) + 1,
    };
  });

  return {
    ...el,
    enFillersShuffled,
  };
};
